import { render, staticRenderFns } from "./StatsCounty.vue?vue&type=template&id=fb2b7732"
import script from "./StatsCounty.vue?vue&type=script&lang=js"
export * from "./StatsCounty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports